import React, {Component} from "react";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import "./Docs.css";
import SiteService from "../../service/SiteService";
import BotIndex from "./BotIndex";
import MocksIndex from "./MocksIndex";

class Index extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs" title="Documentation"/>

                <PageBlock>
                    {SiteService.isBotSite() &&
                    <BotIndex/>}

                    {SiteService.isMocksSite() &&
                    <MocksIndex/>}
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/modules/views/docs/Index.js